export enum ButtonCharacter {
    none = 'none',
    laquo = 'laquo',
    raquo = 'raquo',
    cross = 'cross',
}
